import React, { useState, useEffect } from 'react'
import { ApprovedItem } from './Approved'
import { UnapprovedItem } from './Unapproved'

const Registry = {
    '1': ApprovedItem,
    '0': UnapprovedItem,
}

export const DescriptionItem = (props: any) => {
    const [component, setComonent] = useState<any>({ Com: null })
  
    const regComponentHandle = (type: '1' | '0') => {
        setComonent({ Com: Registry[type] })
    }
  
    const { Com } = component

    useEffect(() => {
      regComponentHandle(props.type)
    }, [props.type])
  
    return (
      <>
        {Com ? <Com {...props} /> : null}
      </>
    );
}
  
export default DescriptionItem